var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cabecalho',{attrs:{"title":"SUPRIMENTOS_LANCAMENTOS_NF.DADOS_PAGAMENTO"}}),_c('tabela-dados-pagamento',{attrs:{"dados":_vm.dados}}),_c('cabecalho',{attrs:{"title":"SUPRIMENTOS_LANCAMENTOS_NF.DADOS_PARCELAMENTO"}}),_c('tabela-parcelamento',{attrs:{"dados":_vm.dados}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }